import * as React from 'react';
import * as Cx from 'classnames';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
const { firebaseConnect } = require('react-redux-firebase');

import './nav.css';

import { RootState } from '../reducers/root';

interface NavStateProps {
  auth: {
    isLoaded: boolean;
    isEmpty: boolean;
  };
}

interface NavRouterProps extends RouteComponentProps<{}> {}

interface NavProps extends NavStateProps, NavRouterProps {
  firebase: {
    logout: () => void;
  };
}

interface NavState {
  menuIsActive: boolean;
}

interface LinkData {
  path: string;
  text: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}

class Nav extends React.PureComponent<NavProps, NavState> {
  state = {
    menuIsActive: false,
  };

  hamburgerToggle = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    this.setState(prevState => ({ menuIsActive: !prevState.menuIsActive }));
  };

  dismissNav = () => this.setState(() => ({ menuIsActive: false }));

  navOptionsClass(): string {
    return Cx({
      'navbar-menu': true,
      'is-active': this.state.menuIsActive,
    });
  }

  navBurgerClass(): string {
    return Cx({
      'navbar-burger': true,
      burger: true,
      'is-active': this.state.menuIsActive,
    });
  }

  navItemClass(navItemPath: string): string {
    return Cx({
      'navbar-item': true,
      'is-active': this.props.location.pathname.startsWith(navItemPath),
      'is-uppercase': true,
    });
  }

  logout = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    this.props.firebase.logout();
    this.dismissNav();
  };

  get linkData(): LinkData[] {
    return [
      { path: '/about', text: 'About Us' },
      { path: '/events', text: 'Events' },
      { path: '/accommodations', text: 'Accommodations' },
      { path: '/location', text: 'Location' },
      { path: '/registry', text: 'Registry' },
      { path: '/questions', text: 'Questions' },
      { path: '/contact', text: 'Contact' },
    ];
  }

  get authedLinkData(): LinkData[] {
    if (!this.props.auth.isLoaded || this.props.auth.isEmpty) {
      return [{ path: '/rsvp', text: 'RSVP' }];
    }
    return [{ path: '/admin', text: 'Admin' }, { path: '/logout', text: 'Logout', onClick: this.logout }];
  }

  get links(): JSX.Element[] {
    return this.linkData.concat(this.authedLinkData).map(({ path, text, onClick }) => (
      <Link key={path} to={path} className={this.navItemClass(path)} onClick={onClick || this.dismissNav}>
        {text}
      </Link>
    ));
  }

  render(): JSX.Element {
    return (
      <div className="root-nav">
        <nav className="navbar">
          <div className="navbar-brand" onClick={this.dismissNav}>
            <Link to="/" className="navbar-item is-cursive is-size-3-desktop is-size-4-touch" onClick={this.dismissNav}>
              Briana &amp; Matt
            </Link>

            <span className={this.navBurgerClass()} onClick={this.hamburgerToggle}>
              <span />
              <span />
              <span />
            </span>
          </div>

          <div className={this.navOptionsClass()}>
            <div className="navbar-end">{this.links}</div>
          </div>
        </nav>
        {this.state.menuIsActive ? <div className="clickscreen" onClick={this.dismissNav} /> : null}
      </div>
    );
  }
}

function mapStateToProps(state: RootState, _ownProps: NavRouterProps): NavStateProps {
  return {
    auth: state.firebase.auth,
  };
}

export default withRouter(
  connect<NavStateProps, {}, NavRouterProps>(mapStateToProps)(firebaseConnect()(Nav)),
) as React.ComponentClass<{}>;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/nav.tsx